<div class="dx-card wide-card">
    <h4 class="content-block ap-green">H2 Steam Reformer/ASU Awards by Country</h4>
    <div class="content-block">
        <dx-responsive-box labelLocation="top" singleColumnScreen="xs sm md">
            <dxi-row [ratio]="1"></dxi-row>
            <dxi-col [ratio]="1"></dxi-col>
            <dxi-col [ratio]="1"></dxi-col>
            <dxi-col [ratio]="1"></dxi-col>
            <dxi-col [ratio]="1"></dxi-col>
            <dxi-col [ratio]=".5"></dxi-col>
            <dxi-item>
                <dxi-location [row]="0" [col]="0"></dxi-location>
                <div class="dx-field">
                    <div class="dx-field-label"><span class="error">*</span> Country</div>
                    <div class="dx-field-value">
                        <dx-select-box #country (onValueChanged)="onCountryChanged($event)" [showClearButton]="true"
                            [searchEnabled]="true" [(value)]="selectedCountry" [items]="countryDataSource">
                            <dx-validator>
                                <dxi-validation-rule type="required" message="Country is required">
                                </dxi-validation-rule>
                            </dx-validator>
                        </dx-select-box>
                    </div>
                </div>
            </dxi-item>
            <dxi-item>
                <dxi-location [row]="0" [col]="1"></dxi-location>
                <div class="dx-field">
                    <div class="dx-field-label"><span class="error">*</span> State/Province</div>
                    <div class="dx-field-value">
                        <dx-tag-box [items]="provinceDataSource" [searchEnabled]="true" [maxFilterQueryLength]="50000"
                            [multiline]="false" (onValueChanged)="onProvinceChanged($event)"
                            [(value)]="selectedProvinces" [showSelectionControls]="true">
                            <dx-validator>
                                <dxi-validation-rule type="required" message="Province is required">
                                </dxi-validation-rule>
                            </dx-validator>
                        </dx-tag-box>
                    </div>
                </div>

            </dxi-item>
            <dxi-item>
                <dxi-location [row]="0" [col]="2"></dxi-location>
                <div class="dx-field">
                    <div class="dx-field-label"><span class="error">*</span> City</div>
                    <div class="dx-field-value">
                        <dx-tag-box [items]="cityDataSource" [searchEnabled]="true" [maxFilterQueryLength]="50000"
                            [multiline]="false" [(value)]="selectedCities" [showSelectionControls]="true">
                            <dx-validator>
                                <dxi-validation-rule type="required" message="City is required">
                                </dxi-validation-rule>
                            </dx-validator>
                        </dx-tag-box>
                    </div>
                </div>

            </dxi-item>
            <dxi-item>
                <dxi-location [row]="0" [col]="3"></dxi-location>
                <div class="dx-field">
                    <div class="dx-field-value">
                        <dx-check-box [(value)]="addASUAwards" text="Add ASU Awards"></dx-check-box>
                    </div>
                </div>
            </dxi-item>
            <dxi-item>
                <dxi-location [row]="0" [col]="4"></dxi-location>
                <div class="dx-field">
                    <dx-button class="ap-blue-btn" type="default" (onClick)="getReports()" text="View Reports">
                    </dx-button>
                </div>
            </dxi-item>
        </dx-responsive-box>
    </div>
    <hr />
    <div class="content-block">
        <div id="map" style="float: left;margin-right: 15px;"></div>
        <div id="techProviderLegend">
            <b>Color = Tech Provider</b>
            <hr />
        </div>
        <div *ngIf="addASUAwards" id="manufacturerLegend">
            <b>Color = ASU Manufacturer</b>
            <hr />
        </div>
        <div id="sizeLegend">
            <b>Size = H2 Qty (kNm3/h)</b>
            <hr />
        </div>
        <div *ngIf="addASUAwards" id="asuSizeLegend">
            <b>Size = ASU O2 Qty (tonne/d)</b>
            <hr />
        </div>
    </div>
    <div class="marginB15"></div>
    <h4 class="content-block ap-green" style="padding-right:69%">Steam Reformer Details...</h4>
    <dx-data-grid class="gridmargin" #H2AwardsSteamReformersGrid id="H2AwardsSteamReformersGrid"
        [dataSource]="reportDataSource" [showRowLines]="true" [showColumnLines]="true" [showBorders]="true"
        [allowColumnResizing]="true" [columnAutoWidth]="true" [rowAlternationEnabled]="true">
        <dxo-filter-row [visible]="true"></dxo-filter-row>
        <dxo-filter-panel [visible]="false"></dxo-filter-panel>
        <dxo-paging [enabled]="true" [pageSize]="10"></dxo-paging>
        <dxo-sorting mode="multiple"></dxo-sorting>
        <dxo-header-filter [visible]="true"></dxo-header-filter>
        <dxo-search-panel [visible]="true"></dxo-search-panel>
        <dxo-scrolling columnRenderingMode="virtual"></dxo-scrolling>
        <dxo-export [enabled]="true"></dxo-export>
        <dxo-column-fixing [enabled]="true"></dxo-column-fixing>
        <dxo-selection mode="single" showCheckBoxesMode="always"></dxo-selection>
        <dxo-toolbar>
            <dxi-item name="groupPanel"></dxi-item>
            <dxi-item location="after">
                <dx-button icon="exportxlsx" stylingMode="contained" type="default" text="Export to Excel"
                    (onClick)="exportExcel($event)">
                </dx-button>
            </dxi-item>
        </dxo-toolbar>
        <dxi-column dataField="countryName" caption="Country"></dxi-column>
        <dxi-column caption="State/Province" dataField="province"></dxi-column>
        <dxi-column dataField="city"></dxi-column>
        <dxi-column dataField="owner"></dxi-column>
        <dxi-column dataField="customer"></dxi-column>
        <dxi-column dataField="technologyProvider"></dxi-column>
        <dxi-column dataField="onstreamYear"></dxi-column>
        <dxi-column dataField="hydrogen" caption="Hydrogen (kNm3/h)">
            <dxo-format type="fixedPoint" [precision]="0"></dxo-format>
        </dxi-column>
    </dx-data-grid>
    <h4 class="content-block ap-green" style="padding-right:69%" *ngIf="addASUAwards">Air Separation Unit Details...
    </h4>
    <dx-data-grid *ngIf="addASUAwards" class="gridmargin" #ASUAwardsReportGrid id="ASUAwardsReportGrid"
        [dataSource]="asuAwardsReportDataSource" [showRowLines]="true" [showColumnLines]="true" [showBorders]="true"
        [allowColumnResizing]="false" [columnAutoWidth]="true" [rowAlternationEnabled]="true">
        <dxo-filter-row [visible]="true"></dxo-filter-row>
        <dxo-filter-panel [visible]="false"></dxo-filter-panel>
        <dxo-paging [enabled]="true" [pageSize]="10"></dxo-paging>
        <dxo-sorting mode="multiple"></dxo-sorting>
        <dxo-header-filter [visible]="true"></dxo-header-filter>
        <dxo-search-panel [visible]="true"></dxo-search-panel>
        <dxo-scrolling columnRenderingMode="virtual"></dxo-scrolling>
        <dxo-export [enabled]="true"></dxo-export>
        <dxo-column-fixing [enabled]="true"></dxo-column-fixing>
        <dxo-selection mode="single" showCheckBoxesMode="always"></dxo-selection>
        <dxo-toolbar>
            <dxi-item name="groupPanel"></dxi-item>
            <dxi-item location="after">
                <dx-button icon="exportxlsx" stylingMode="contained" type="default" text="Export to Excel"
                    (onClick)="exportASUAwardsExcel($event)">
                </dx-button>
            </dxi-item>
        </dxo-toolbar>
        <dxi-column dataField="countryName" caption="Country"></dxi-column>
        <dxi-column dataField="province" caption="State/Province"></dxi-column>
        <dxi-column dataField="city"></dxi-column>
        <dxi-column dataField="owner"></dxi-column>
        <dxi-column dataField="customer"></dxi-column>
        <dxi-column dataField="manufacturer"></dxi-column>
        <dxi-column dataField="onstreamYear"></dxi-column>
        <dxi-column dataField="totalOxygen" caption="Oxygen (tonne/d)">
            <dxo-format type="fixedPoint" [precision]="0"></dxo-format>
        </dxi-column>
    </dx-data-grid>
    <dx-load-panel #dxLoadPanel shadingColor="rgba(0,0,0,0.4)" [visible]="isLoadPanelVisible" [showPane]="true"
        [shading]="false" [closeOnOutsideClick]="false">
    </dx-load-panel>
</div>